import { createContext } from "react";

/**
 * What every cell of one grid shares, provided once by `DataGrid` instead of each `TableCell`
 * subscribing to it on its own. Each cell used to call `useOpenSubscriptionForm()` (router, Jotai,
 * a promo-code effect and a cookie read per render) and `useRouter()`, so a grid of 40 rows x 15
 * columns ran those 600 times per render and re-rendered every cell on any route change, including
 * a shallow `?tab=` switch. The value is stable: `openSubscriptionForm` reads the grid's latest
 * handler through a ref.
 */
export interface TableCellShared {
    /** Opens the payment form (an obfuscated cell's click). */
    openSubscriptionForm: () => void;
}

export const TableCellContext = createContext<TableCellShared>({ openSubscriptionForm: () => undefined });

/** The page's path, read when a cell formats a value (no router subscription per cell). */
export const currentPathname = (): string => (typeof window === "undefined" ? "" : window.location.pathname);
